export enum RoleType {
  super_admin = 100, // 超级管理员
  admin = 101, // 管理员
  agency_observer = 102, // 报表分析员
  financial_officer = 103, // 财务人员
  operator = 108, // 运营人员
  operation_supervisor = 114, // 运营管理员
  designer = 116, // 设计师
  observer = 118, // 观察者
}

// 角色类型
export interface Role {
  role_code: string;                              // 角色code
  role_id: RoleType;                              // 角色id
  role_name: string;                              // 角色名称
}
